<template>
    <div>
        <v-dialog v-model="abrir" persistent max-width="50%" >
            <v-card class="pb-1">
                <v-card-title class="justify-space-between">
                    <span class="headline">Editar roles</span>
                    <v-btn color="red darken-1" dark @click="cerrarModal()">Cerrar</v-btn>
                </v-card-title>
                
                <v-col cols="12" class="mt-2 mb-4">
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="name"
                                label="Nombre"
                                class="pt-1 mb-1" 
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                v-model="user"
                                label="Usuario (RUT)"
                                class="pt-1 mb-1"
                                readonly
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                v-model="email"
                                label="E-mail"
                                class="pt-1 mb-1" 
                                readonly
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-select
                                :items="roles"
                                item-text="name"
                                item-value="id"
                                v-model="roles_seleccionados"
                                multiple
                                small-chips
                                label="Roles"
                                class="pt-1 mb-1" 
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-col>
                <v-row>
                    <v-progress-linear 
                        v-if="progreso"
                        indeterminate
                        color="#0D47A1"
                    ></v-progress-linear>
                </v-row>
                <div class="d-flex justify-center pt-5 pb-4">
                    <v-btn color="blue darken-1" dark @click="modificarRoles">Modificar roles</v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
    data:() => ({
        id: 0,
        name: '',
        user: '',
        email: '',
        roles: [],
        roles_seleccionados: [],
        abrir: false,
        progreso: false,
    }),
    methods: {
        async modificarRoles() {
            this.mostrarLoading({ titulo: "Modificando roles...", color:'green' });
            this.progreso = true;

            const data = { 
                user: this.user,
                roles: this.roles_seleccionados,
            };

            const url = `${this.base_url}user/modificar_roles/${this.id}`;

            await this.axios.put(url, data, this.headers).then(res => {
                console.log("Roles modificados exitosamente", res.data.data);
                this.ocultarLoading();
                this.cerrarModal(true);

                this.limpiarCampos();
            }).catch(e => {
                this.errorMessage(e, "Error al modificar roles");
            });
            this.progreso = false;
        },
        limpiarCampos() {
            // Limpia inputs
            this.id = 0;
            this.name = '';
            this.user = '';
            this.email = '';
            this.roles_seleccionados = [];
        },
        abrirModal([roles, user]) {
            this.id = user.id;
            this.name = user.name;
            this.user = user.user;
            this.email = user.email;
            this.roles_seleccionados = user.roles;
            this.roles = roles;
            this.abrir = true;
        },
        cerrarModal(cargarDatos = false) {
            if(cargarDatos) {
                this.$emit('cargar_usuarios');
            }
            this.abrir = false;
        },
        ...mapMutations(['mostrarLoading','ocultarLoading'])
    },
    computed: {
      ...mapState(['base_url', 'headers']),
    },
}
</script>

<style scoped>
</style>